import { useQuery } from '@tanstack/react-query';
import { camelCase } from 'change-case';
import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { QueryKey } from 'types/query';

export const useTenantDistinctedLabelsQuery = () => {
  return useQuery(
    [QueryKey.useTenantDistinctedLabelsQuery],
    async () => {
      const { data } = await campaignsClient.getDistinctedLabels();

      return Array.from(new Set(data.map((label) => camelCase(label))));
    },
    {
      keepPreviousData: true,
    },
  );
};
